/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetTypeModel } from './PetTypeModel';
import {
    PetTypeModelFromJSON,
    PetTypeModelFromJSONTyped,
    PetTypeModelToJSON,
} from './PetTypeModel';

/**
 * 
 * @export
 * @interface PetV2FormConfigurationModel
 */
export interface PetV2FormConfigurationModel {
    /**
     * 
     * @type {string}
     * @memberof PetV2FormConfigurationModel
     */
    usecase?: PetV2FormConfigurationModelUsecaseEnum;
    /**
     * 
     * @type {string}
     * @memberof PetV2FormConfigurationModel
     */
    action: PetV2FormConfigurationModelActionEnum;
    /**
     * 
     * @type {PetTypeModel}
     * @memberof PetV2FormConfigurationModel
     */
    petType?: PetTypeModel;
}


/**
 * @export
 */
export const PetV2FormConfigurationModelUsecaseEnum = {
    Pharmacy: 'pharmacy',
    VetDiet: 'vetDiet',
    Basic: 'basic',
    Cwav: 'cwav',
    Insurance: 'insurance'
} as const;
export type PetV2FormConfigurationModelUsecaseEnum = typeof PetV2FormConfigurationModelUsecaseEnum[keyof typeof PetV2FormConfigurationModelUsecaseEnum];

/**
 * @export
 */
export const PetV2FormConfigurationModelActionEnum = {
    Create: 'create',
    Edit: 'edit'
} as const;
export type PetV2FormConfigurationModelActionEnum = typeof PetV2FormConfigurationModelActionEnum[keyof typeof PetV2FormConfigurationModelActionEnum];


/**
 * Check if a given object implements the PetV2FormConfigurationModel interface.
 */
export function instanceOfPetV2FormConfigurationModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "action" in value;

    return isInstance;
}

export function PetV2FormConfigurationModelFromJSON(json: any): PetV2FormConfigurationModel {
    return PetV2FormConfigurationModelFromJSONTyped(json, false);
}

export function PetV2FormConfigurationModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetV2FormConfigurationModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'usecase': !exists(json, 'usecase') ? undefined : json['usecase'],
        'action': json['action'],
        'petType': !exists(json, 'petType') ? undefined : PetTypeModelFromJSON(json['petType']),
    };
}

export function PetV2FormConfigurationModelToJSON(value?: PetV2FormConfigurationModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'usecase': value.usecase,
        'action': value.action,
        'petType': PetTypeModelToJSON(value.petType),
    };
}

